<script lang="ts">
  import {slide} from 'svelte/transition';
  import {transitionParams} from 'Components/Common/Transitions/transitionParams';
</script>

<div transition:slide|local={transitionParams}>
  <slot />
</div>
